import { Col, Row } from 'reactstrap';
import AdminPage from '../../components/admin/AdminPage';
import InvestorProjectResumeConfigCard from './components/InvestorProjectResumeConfigCard';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import ProjectUpdateLayoutCard from './components/ProjectUpdateLayoutCard';

const InvestorProjectLayoutConfig = () => {
  const { id = '' } = useParams();

  const [projectResumeId, setProjectResumeId] = useState<string>('');

  const handleUpdateLayout = (projectResumeId: string) => {
    setProjectResumeId(projectResumeId);
  };

  return (
    <AdminPage
      name="Configuración tipo de layout en marketplace"
      parentName="Proyectos"
    >
      <Row>
        <Col md="6">
          <InvestorProjectResumeConfigCard
            projectId={id}
            handleProjectResumeId={handleUpdateLayout}
          />
        </Col>
        <Col md="6">
          {projectResumeId && <ProjectUpdateLayoutCard projectId={id} />}
        </Col>
      </Row>
    </AdminPage>
  );
};

export default InvestorProjectLayoutConfig;
